import ImageOptimize from '@/components/ImageOptimize'
import type { Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'

interface HighlightPropertiesProps {
  position: 'top' | 'right'
  data: Property[]
}

const HighlightProperties = ({ position, data }: HighlightPropertiesProps) => {
  const renderData = data
    .sort((x, y) => (x?.order || 0) - (y?.order || 0))
    .slice(0, 3)

  return (
    <div
      className={`absolute top-0 flex ${
        position === 'right'
          ? 'right-0 h-full min-w-[25%] max-w-[25%] flex-col items-center gap-1.5'
          : 'left-0 max-h-[25%] min-h-[25%] w-full gap-2'
      } justify-center`}
    >
      {renderData.map(item => (
        <div
          className={`${
            position === 'top' ? 'w-[33%]' : ''
          } flex flex-col items-center`}
          key={item._id}
        >
          <ImageOptimize
            alt={getTranslate(item.name)}
            src={item.image || ''}
            className='h-4 w-4'
          />
          <p className='mt-1 text-center text-[9px] leading-[11px] text-main'>
            {item.value
              ? getTranslate(item.value)
              : item.values
                  .map(x => getTranslate(x.value))
                  .join('\n')
                  .substring(0, 30)}
          </p>
        </div>
      ))}
    </div>
  )
}

export default HighlightProperties
